import { render, staticRenderFns } from "./EmptyTransloadIcon.vue?vue&type=template&id=2974ff3d"
import script from "./EmptyTransloadIcon.vue?vue&type=script&lang=js"
export * from "./EmptyTransloadIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports